import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';

type RestaurantPresentationState = {
  sampleMenu?: { isOpen: boolean };
  widgetPosition?: string;
};

const StateContext = createContext<RestaurantPresentationState>({});
const UpdateContext = createContext<((patch: RestaurantPresentationState) => void) | undefined>(
  undefined
);

export function RestaurantPresentationProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<RestaurantPresentationState>({});
  const update = useCallback((patch: RestaurantPresentationState) => {
    setState((previous) => {
      const next = { ...previous, ...patch };
      if (
        next.sampleMenu?.isOpen === previous.sampleMenu?.isOpen &&
        next.widgetPosition === previous.widgetPosition
      ) {
        return previous;
      }
      return next;
    });
  }, []);

  return (
    <UpdateContext.Provider value={update}>
      <StateContext.Provider value={state}>{children}</StateContext.Provider>
    </UpdateContext.Provider>
  );
}

export const useRestaurantPresentationState = () => useContext(StateContext);

export function useUpdateRestaurantPresentation() {
  const update = useContext(UpdateContext);
  if (!update) throw new Error('Restaurant presentation requires its provider');
  return update;
}
